import { baseApi } from './baseApi';
import { PaymentOrder } from '../../types';

export const paymentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createPaymentOrder: builder.mutation<
      PaymentOrder,
      {
        pageCount: number;
        documentCount?: number;
        copies: number;
        printType: 'bw' | 'color';
        paperSize?: string;
        paperType?: string;
        fileName: string;
        userId: string;
        ownerId?: string;
      }
    >({
      query: (body) => ({
        url: '/payment/create-order',
        method: 'POST',
        body,
      }),
    }),
    verifyPayment: builder.mutation<
      { success: boolean; paymentId: string; orderId: string },
      {
        razorpay_order_id: string;
        razorpay_payment_id: string;
        razorpay_signature: string;
      }
    >({
      query: (body) => ({
        url: '/payment/verify-payment',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useCreatePaymentOrderMutation, useVerifyPaymentMutation } = paymentApi;
